class closeAddonPopup extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    this.closest(".free-addon-product-main").classList.remove("active");
    document.querySelector("body").classList.remove("no-scroll");
    // console.log(this);
  }
}

customElements.define("close-addon-popup", closeAddonPopup);

class openAddonModal extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const closestItemCard = this.closest(".closest-item-card");
    const addonProductMain = this.closest(".free-addon-product-main");
    const selectElement = closestItemCard.querySelector(
      "product-qty-selector select"
    );

    const cartQtyValue = closestItemCard.querySelector("cart-qty-input input");

    let cartTotalFreeProduct = 0;

    if (closestItemCard.querySelector(".free-addon-product-main")) {
      const productId = closestItemCard.querySelector(
        ".free-addon-product-main"
      ).dataset.productId;

      document
        .querySelectorAll(
          `.free-product-text-cart[data-product-id="${productId}"]`
        )
        .forEach((item) => {
          const qty = parseInt(item.dataset.qty, 10);
          cartTotalFreeProduct += isNaN(qty) ? 0 : qty;
        });

      // console.log("Total Qty:", cartTotalFreeProduct);
      // console.log(cartQtyValue.value);

      if (cartQtyValue) {
        cartTotalFreeProduct = cartQtyValue.value - cartTotalFreeProduct;
      }
    }

    const selectValue =
      selectElement && selectElement.value
        ? selectElement.value
        : cartTotalFreeProduct && cartTotalFreeProduct
        ? cartTotalFreeProduct
        : cartQtyValue && cartQtyValue.value
        ? cartQtyValue.value
        : 1;

    addonProductMain.querySelector(
      ".free-addon-product-main .upto-text"
    ).textContent = selectValue;

    addonProductMain
      .querySelector(".free-addon-product-main .upto-text")
      .setAttribute("data-value", selectValue);
    addonProductMain.classList.add("active");
    document.querySelector("body").classList.add("no-scroll");
    // console.log(this);
  }
}

customElements.define("open-addon-modal", openAddonModal);

class GiftCardSelector extends HTMLElement {
  constructor() {
    super();
    this.handleCardClick = this.handleCardClick.bind(this);
  }

  connectedCallback() {
    this.cardElements = this.querySelectorAll(".gift-card-main .gift-card");

    this.cardElements.forEach((card) => {
      card.addEventListener("click", this.handleCardClick);
    });
  }

  disconnectedCallback() {
    this.cardElements.forEach((card) => {
      card.removeEventListener("click", this.handleCardClick);
    });
  }

  handleCardClick(event) {
    const card = event.currentTarget;

    const closestItemCard = this.closest(".closest-item-card");

    const selectElement = closestItemCard.querySelector(
      "product-qty-selector select"
    );
    const cartQtyValue = closestItemCard.querySelector("cart-qty-input input");

    let cartTotalFreeProduct = 0;
    if (closestItemCard.querySelector(".free-addon-product-main")) {
      const productId = closestItemCard.querySelector(
        ".free-addon-product-main"
      ).dataset.productId;

      document
        .querySelectorAll(
          `.free-product-text-cart[data-product-id="${productId}"]`
        )
        .forEach((item) => {
          const qty = parseInt(item.dataset.qty, 10);
          cartTotalFreeProduct += isNaN(qty) ? 0 : qty;
        });

      if (cartQtyValue) {
        cartTotalFreeProduct = cartQtyValue.value - cartTotalFreeProduct;
      }
    }

    const selectValue =
      selectElement && selectElement.value
        ? selectElement.value
        : cartTotalFreeProduct && cartTotalFreeProduct
        ? cartTotalFreeProduct
        : cartQtyValue && cartQtyValue.value
        ? cartQtyValue.value
        : 1;

    const selectedCards = this.querySelectorAll(".gift-card.selected");

    if (card.classList.contains("selected")) {
      card.classList.remove("selected");
    } else if (selectedCards.length < selectValue) {
      card.classList.add("selected");
    } else {
      // alert(`You can only select up to ${selectValue} gift cards.`);
    }

    if (
      this.querySelectorAll(".gift-card.selected").length ==
      parseInt(selectValue)
    ) {
      this.querySelectorAll(".gift-card").forEach((card) => {
        if (!card.classList.contains("selected")) {
          card.classList.add("disabled");
        }
      });
    } else {
      this.querySelectorAll(".gift-card").forEach((card) => {
        card.classList.remove("disabled");
      });
    }

    if (this.querySelectorAll(".gift-card.selected").length > 0) {
      this.closest(".closest-item-card")
        .querySelector(".add-products-btn")
        .classList.remove("disabled");
    } else {
      this.closest(".closest-item-card")
        .querySelector(".add-products-btn")
        .classList.add("disabled");
    }
  }
}

customElements.define("gift-card-selector", GiftCardSelector);
class customAddCart extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const $this = this;
    window.freeGiftAddCart($this);
  }
}

customElements.define("custom-add-cart", customAddCart);

window.freeGiftAddCart = function ($this) {
  $this.classList.add("active");

  const selectedGiftCards = $this
    .closest(".closest-item-card")
    .querySelectorAll(".gift-card.selected");

  const variants = [];
  selectedGiftCards.forEach((card) => {
    const variantId = card.dataset.variantId;
    const productId = card.dataset.productId;
    variants.push({ variantId, productId });
  });

  let itemsArr = new Array();

  for (let i = 0; i < variants.length; i++) {
    const { variantId, productId } = variants[i];
    itemsArr.push({
      id: variantId,
      quantity: 1,
      properties: {
        _free_gift: true,
        _product_id: productId + "-" + variantId,
      },
    });
  }

  const formData = {
    items: itemsArr,
  };

  if (formData.items.length > 0) {
    fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
      })
      .finally(() => {
        if ($this.closest(".custom-add-to-cart-main")) {
          $this
            .closest(".custom-add-to-cart-main")
            .querySelector("button")
            .click();
        } else {
          window.location.href = "/cart";
        }
      });
  } else {
    $this.closest(".custom-add-to-cart-main").querySelector("button").click();
  }
};

window.freeGiftRemoveCart = function ($this) {
  console.log("remove cart");

  if ($this.querySelectorAll(".free-product-text-cart").length == 0) return;
  let updates = {};
  $this.querySelectorAll(".free-product-text-cart")?.forEach((item) => {
    let removeFreeProductId = item.dataset.id;
    updates[removeFreeProductId] = 0;
  });
  // console.log($this);

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      // return response.json();
    })
    .finally(() => {
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".closest-item-card product-qty-selector select")
    .forEach((select) => {
      select.addEventListener("change", function () {
        this.closest(".closest-item-card")
          .querySelectorAll(".gift-card-main .gift-card")
          .forEach((card) => {
            card.classList.remove("selected", "disabled");
          });
      });
    });

  const toggleBtn = document.querySelector(".filter-toggle");
  if (toggleBtn) {
    toggleBtn.addEventListener("click", (btn) => {
      btn.currentTarget.classList.toggle("show-toggle");
      const productGridWrapper = document.querySelector(
        ".collection-container"
      );
      if (productGridWrapper) {
        productGridWrapper.classList.toggle("show-filter");
      }
    });
  }
});
